import { FullOffer } from '../offer/offer';

export class PricingOffer {
    offerKey?: number;
    advancePayment?: number;
    fixedPrice?: number;
    isPayableAtClub?: boolean;
    isPayableOnline?: boolean;
    pricing: Pricing[];
    discount: Discount[];

    constructor(data: FullOffer) {
        this.offerKey = data.offerKey;
        this.advancePayment = data.advancePayment;
        this.fixedPrice = data.fixedPrice;
        this.isPayableAtClub = data.isPayableAtClub;
        this.isPayableOnline = data.isPayableOnline;
        this.pricing = data.pricing;
        this.discount = data.discount;
    }
}

export class Pricing {
    limits: MinMax | string;
    price: number;

    constructor(limits: MinMax | string, price: number) {
        this.limits = limits;
        this.price = price;
    }
}

interface MinMax {
    min: number;
    max: number;
}

export class RemVRES {
    values: string;
    percentage: number;

    constructor(value: string, percentage: number) {
        this.values = value;
        this.percentage = percentage;
    }
}

export class Discount {
    discountName: string;
    criteria: any;
    discount: number;

    constructor(discountName: string, criteria: any = null, discount: number = null) {
        this.discountName = discountName;
        this.criteria = criteria;
        this.discount = discount;
    }
}
